import React, { useEffect, useState } from 'react';
import { Table, Button, Tag, message, Card, Input, Form, Space } from 'antd';
import { DownloadOutlined, ReloadOutlined, MailOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../../api/axios';

const BackupTab = () => {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [mailForm] = Form.useForm();
  const [savingMail, setSavingMail] = useState(false);

  const fetchBackups = async () => {
    setLoading(true);
    try {
      const res = await api.get('/backups');
      setBackups(res.data);
    } catch {
      message.error('Yedekler yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  const fetchMailRecipient = async () => {
    try {
      const res = await api.get('/backups/settings/mail');
      mailForm.setFieldsValue({ email: res.data.email });
    } catch {}
  };

  const handleSaveMail = async (values) => {
    setSavingMail(true);
    try {
      await api.post('/backups/settings/mail', values);
      message.success('Mail adresi güncellendi.');
    } catch {
      message.error('Güncelleme başarısız.');
    } finally {
      setSavingMail(false);
    }
  };

  useEffect(() => { fetchBackups(); fetchMailRecipient(); }, []);

  const handleDownload = async (filename) => {
    setDownloading(filename);
    try {
      const res = await api.get(`/backups/${filename}/download`, { responseType: 'blob' });
      const url  = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      message.error('İndirme başarısız.');
    } finally {
      setDownloading(null);
    }
  };

  const columns = [
    {
      title: 'Dosya Adı',
      dataIndex: 'name',
      key: 'name',
      render: (v) => <span className="font-mono text-sm">{v}</span>,
    },
    {
      title: 'Boyut',
      dataIndex: 'size_mb',
      key: 'size_mb',
      render: (v) => {
        const color = v < 5 ? 'green' : v < 20 ? 'orange' : 'red';
        return <Tag color={color}>{v} MB</Tag>;
      },
    },
    {
      title: 'Tarih',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (v) => dayjs(v).format('DD.MM.YYYY HH:mm'),
    },
    {
      title: 'İşlem',
      key: 'action',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<DownloadOutlined />}
          loading={downloading === record.name}
          onClick={() => handleDownload(record.name)}
        >
          İndir
        </Button>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <Card title={<span><MailOutlined className="mr-2" />Yedek Mail Adresi</span>}>
        <Form form={mailForm} layout="inline" onFinish={handleSaveMail}>
          <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Geçerli mail giriniz.' }]}>
            <Input placeholder="ornek@mail.com" style={{ width: 300 }} prefix={<MailOutlined />} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={savingMail}>Kaydet</Button>
          </Form.Item>
        </Form>
        <p className="text-gray-400 text-xs mt-2">Her gece 02:00'deki otomatik yedek bu adrese gönderilir.</p>
      </Card>

    <Card
      title="Veritabanı Yedekleri"
      extra={
        <Button icon={<ReloadOutlined />} onClick={fetchBackups} loading={loading}>
          Yenile
        </Button>
      }
    >
      <p className="text-gray-500 text-sm mb-4">
        Yedekler her gece 02:00'de otomatik alınır ve 7 gün saklanır.
      </p>
      <Table
        columns={columns}
        dataSource={backups}
        rowKey="name"
        loading={loading}
        pagination={false}
      />
    </Card>
    </div>
  );
};

export default BackupTab;
